import { get, post, put } from '..'
import type {
    Enroll
} from '@/models/enrolls/enroll'

export async function fetchEnrollConfig() {
    const { data } = await get(`EnrollConfig/ALLKey`)
    return data as Enroll[]
  }